export function useSearchParams(): URLSearchParams {
  if (typeof window === 'undefined') return new URLSearchParams();
  return new URLSearchParams(window.location.search);
}

export function usePathname(): string {
  if (typeof window === 'undefined') return '';
  return window.location.pathname;
}

type Router = {
  push: (href: string) => void;
  replace: (href: string) => void;
  back: () => void;
  forward: () => void;
  refresh: () => void;
  prefetch: (_href: string) => Promise<void>;
};

export function useRouter(): Router {
  return {
    push: (href: string) => {
      window.location.href = href;
    },
    replace: (href: string) => {
      window.location.replace(href);
    },
    back: () => {
      window.history.back();
    },
    forward: () => {
      window.history.forward();
    },
    refresh: () => {
      window.location.reload();
    },
    prefetch: async () => {
      // no-op in WP embed
    },
  };
}

export function useParams(): Record<string, string> {
  // No Next route params in a WP embed context.
  return {};
}

export function notFound(): never {
  throw new Error('notFound() called in WordPress embed');
}

